'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SubscriptionFactory;

var _wildemitter = require('wildemitter');

var _wildemitter2 = _interopRequireDefault(_wildemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function streamer(state) {
    var mainSubscription = void 0;

    var onUpdate = function onUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        state.emit.apply(state, ['update'].concat(args));
    };

    var onClose = function onClose() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        state.emit.apply(state, ['close'].concat(args));
        if (mainSubscription && mainSubscription.off) {
            mainSubscription.off('close', onClose);
            mainSubscription.off('update', onUpdate);
        }
        mainSubscription = null;
    };

    return {
        /**
         * Subscribes for passed subscription events and transfers them.
         * [API subscription DOC]{@link http://docs.pushtechnology.com/docs/5.7.5/js/Subscription.html}
         * @memberOf Subscription
         * @instance
         * @param {Subscription} subscription Subscription for wrapping.
         */
        subscribe: function subscribe(subscription) {
            mainSubscription = subscription;
            subscription.on('close', onClose);
            subscription.on('update', onUpdate);
        },

        setSubscription: function setSubscription(subscription) {
            mainSubscription = subscription;
        },

        onClose: onClose,

        onUpdate: onUpdate,

        /**
         * Close the subscription. No further events will be emitted.
         * Unsubscribe from subscribed events.
         * @memberOf Subscription
         * @instance
         * @throws {Error} Throws if no duffusion sunscription was subscribed.
         */
        close: function close() {
            if (mainSubscription) {
                var _mainSubscription;

                (_mainSubscription = mainSubscription).close.apply(_mainSubscription, arguments);
            }
        },
        fetch: function fetch() {
            if (mainSubscription) {
                var _mainSubscription2;

                (_mainSubscription2 = mainSubscription).fetch.apply(_mainSubscription2, arguments);
            }
        }
    };
}

/**
 * Subscription representation.
 * Wrapper under [diffusion subscription]{@link diffusion.Subscription}
 * @class Subscription
 * @extends {Emitter}
 */
function SubscriptionFactory() {
    var state = new _wildemitter2.default();
    return Object.assign(state, streamer(state));
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/subscription.js
// module id = 403
// module chunks = 1